import { render, staticRenderFns } from "./go-to-top-button.vue?vue&type=template&id=65cecedc&scoped=true"
import script from "./go-to-top-button.vue?vue&type=script&lang=js"
export * from "./go-to-top-button.vue?vue&type=script&lang=js"
import style0 from "./go-to-top-button.vue?vue&type=style&index=0&id=65cecedc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cecedc",
  null
  
)

export default component.exports